import angular from 'angular';

/**
 * Helper directive that runs bootstrap-hover-dropdown jQuery plugin on element
 */
angular.module('commonServices').directive('hoverDropdown', [
  function() {
    return {
      link: function(scope, element, attrs) {
        if (typeof element.dropdownHover !== 'undefined') element.dropdownHover();
      },
    };
  },
]);
